import {
  FormField,
  Header,
  SpaceBetween,
  Textarea,
  Container,
  TokenGroup,
  NonCancelableCustomEvent,
  TokenGroupProps,
} from '@amzn/awsui-components-react-v3';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ScanInput from '../../../../components/ScanInput/index-v3';
import { FormikState } from './schema';

export default function AdditionalInformation({
  form,
  isEditForm,
}: {
  form: FormikState;
  isEditForm: boolean;
}): ReactElement {
  const { t } = useTranslation();

  const handleRemoveTag = (event: NonCancelableCustomEvent<TokenGroupProps.DismissDetail>) => {
    const [...tags] = form.values.tags;
    tags.splice(event.detail.itemIndex, 1);
    form.setFieldValue('tags', tags);
  };

  const handleAddTag = () => {
    if (!form.values.tag || form.errors.tag) {
      return;
    }
    if (form.values.tags.every((i: TokenGroupProps.Item) => i.label !== form.values.tag)) {
      form.setFieldValue('tags', [{ label: form.values.tag }, ...form.values.tags]);
    }
    form.setFieldValue('tag', '');
  };
  return (
    <Container
      header={
        <Header variant="h2" description="">
          {t('Additional Information')}
        </Header>
      }>
      <SpaceBetween direction="vertical" size="m">
        {!isEditForm && (
          <FormField
            description=""
            label={t('Note')}
            errorText={form.touched.note && form.errors.note}>
            <Textarea
              data-test-id="input-note"
              onBlur={() => {
                form.setFieldTouched('note');
              }}
              onChange={(event) => {
                form.setFieldValue('note', event.detail.value);
              }}
              value={form.values.note}
              placeholder={t('Write any notes here')}
            />
          </FormField>
        )}
        <FormField description="" label={t('Tags')} errorText={form.touched.tag && form.errors.tag}>
          <ScanInput
            data-test-id="input-tags"
            value={form.values.tag}
            onInput={(value) => {
              form.setFieldValue('tag', value);
              form.setFieldTouched('tag');
            }}
            onEnter={handleAddTag}
            clearOnEnter
            placeholder={t('Enter tag and press return')}
          />
          <TokenGroup
            data-test-id="list-tags"
            onDismiss={handleRemoveTag}
            items={form.values.tags}
          />
        </FormField>
      </SpaceBetween>
    </Container>
  );
}
